import { render, staticRenderFns } from "./k-filter-only.vue?vue&type=template&id=5b5259a0&scoped=true&"
import script from "./k-filter-only.vue?vue&type=script&lang=ts&"
export * from "./k-filter-only.vue?vue&type=script&lang=ts&"
import style0 from "./k-filter-only.vue?vue&type=style&index=0&id=5b5259a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5259a0",
  null
  
)

export default component.exports